import { cn } from '@Utils/cn';
import { StageStatusBadge } from '../StageStatusBadge';

export interface FlowStageCardProps {
  title: string;
  icon?: React.ReactNode;
  status: any;
  focused?: boolean;
  required?: boolean;
  children: React.ReactNode;
  triggerSection?: React.ReactNode;
  className?: string;
}

export function FlowStageCard({
  title,
  icon,
  status,
  focused,
  required,
  children,
  triggerSection,
  className,
}: FlowStageCardProps) {
  const isDisabled = status === 'next' || status === 'upcoming';

  return (
    <div
      className={cn(
        'border-border bg-card relative w-full rounded-xl border transition-all duration-500',
        focused ? '-mt-9 shadow-2xl' : 'mt-0 shadow-sm',
        isDisabled && !focused && 'opacity-60',
        className,
      )}
    >
      <div className="absolute -top-3 left-1/2 -translate-x-1/2">
        <StageStatusBadge status={status} />
      </div>

      <div className="flex min-w-[20vw] flex-col gap-6 overflow-x-hidden py-6">
        <div
          className={cn(
            'flex items-center px-6 transition-all duration-500',
            focused ? 'gap-2' : 'gap-1.5',
          )}
        >
          {icon && (
            <span
              className={cn(
                'shrink-0 origin-center transition-transform duration-500',
                focused && 'scale-125',
              )}
            >
              {icon}
            </span>
          )}
          <p
            className={cn(
              'text-card-foreground leading-none transition-[font-size] duration-500',
              focused ? 'text-2xl font-bold' : 'text-base font-semibold',
            )}
          >
            {title}
            {required && <span className="text-red-500"> *</span>}
          </p>
        </div>

        <div className="flex flex-col gap-6 px-6">{children}</div>

        {triggerSection}
      </div>
    </div>
  );
}
